import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle, ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const PaymentCanceled = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="container mx-auto px-4 py-12">
        <div className="max-w-2xl mx-auto text-center">
          <Card className="p-8 shadow-warm">
            <div className="mb-6">
              <XCircle className="w-16 h-16 text-orange-500 mx-auto mb-4" />
              <h1 className="text-3xl font-serif font-semibold text-foreground mb-4">
                Paiement annulé
              </h1>
              <p className="text-xl text-muted-foreground">
                Votre commande n'a pas été finalisée
              </p>
            </div>

            <div className="p-4 bg-muted/30 rounded-lg border border-border mb-8">
              <p className="text-sm text-muted-foreground">
                Aucun montant n'a été débité de votre compte. 
                Vos informations de commande ont été conservées, vous pouvez reprendre où vous vous étiez arrêté.
              </p>
            </div>

            <div className="space-y-3">
              <a href="/commande">
                <Button className="w-full bg-primary hover:bg-primary/90" size="lg">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Reprendre ma commande
                </Button>
              </a>
              <a href="/">
                <Button variant="outline" className="w-full" size="lg">
                  Retour à l'accueil
                </Button>
              </a>
            </div>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PaymentCanceled;